import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

// Configurar SweetAlert2 globalmente
const swalOptions = {
  confirmButtonColor: '#1bcfb4',
  cancelButtonColor: '#fe7c96',
  confirmButtonText: 'Ok',
  cancelButtonText: 'Cancelar',
  allowOutsideClick: false,
  allowEscapeKey: false,
};

// Tornar SweetAlert2 disponível globalmente usando SweetAlert2 diretamente
import Swal from 'sweetalert2';
window.$swal = Swal.mixin(swalOptions);

export { VueSweetalert2 };
